<template>
  <v-app id="inspire">
    <Toolbar />
    <v-main class="v-sheet theme--light">
       <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <Footer/>
    <BackofficeChatbot />
  </v-app>
</template>

<script>

import Footer from "@/components/carbon-ui/footer/Footer4.vue";
import Toolbar from "@/components/carbon-ui/toolbar/Toolbar2_backoffice.vue";
import BackofficeChatbot from "@/components/backoffice/BackofficeChatbot.vue";

export default {
  name: "Layout",
  components: {
    Footer,
    Toolbar,
    BackofficeChatbot
  }
}
</script>


